// Auto-generated per-query builders for SysMLElement
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { SysMLElementReadAPI, SysMLElementWriteAPI, SysMLElementReadAPISchema, SysMLElementWriteAPISchema } from '../types/sysmlelement';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, HasMembers } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { SysMLNamespace } from './sysmlnamespace';





// Builder chain for query: pdm-search-context-items

export interface PdmSearchContextItemsBuilder_0 {
  filter(conditions: { search_term: string }): PdmSearchContextItemsBuilder_1;
}

export interface PdmSearchContextItemsBuilder_1 {
  limit(value?: number): PdmSearchContextItemsBuilder_1;
  all(): Promise<SysMLElement[]>;
  first(): Promise<SysMLElement | null>;
  get(): Promise<SysMLElement[]>;
  execute(): Promise<SysMLElement[]>;
}


// Union of all query entry points
export type SysMLElementQueryBuilder = PdmSearchContextItemsBuilder_0;

// Available query names for .setQuery()
export type SysMLElementQueryNames = "pdm-search-context-items";

// Type narrowing for .setQuery()
export type SysMLElementBuilderForQuery<Q extends SysMLElementQueryNames> =
  Q extends "pdm-search-context-items" ? PdmSearchContextItemsBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type SysMLElementInstanceQueryResult<Q extends SysMLElementQueryNames> =
  Q extends "pdm-search-context-items" ? PdmSearchContextItemsBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'filter|limit': 'pdm-search-context-items',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends SysMLElementQueryNames>(queryName: Q): SysMLElementBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface SysMLElement extends Partial<SysMLElementReadAPI> {}
export class SysMLElement extends NeoNodeBase<SysMLElementReadAPI, SysMLElementWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "SysMLElement";
  static readonly readSchema = SysMLElementReadAPISchema;
  static readonly writeSchema = SysMLElementWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    member_namespace: { target: "SysMLNamespace", cardinality: "one", isParent: false, relClass: "HasMembers", direction: "in" },
  };

  protected get modelName(): string {
    return 'SysMLElement';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return SysMLElement.label;
  }


  constructor(data: Partial<SysMLElementWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: SysMLElementReadAPI, loadContext?: Record<string, any>): SysMLElement {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, member_namespace, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = SysMLElementReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, member_namespace: member_namespace };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return SysMLElement.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'member_namespace', 'SysMLNamespace', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new SysMLElement(processed as any);

    return instance;
  }

  static filter(conditions: { search_term: string }): PdmSearchContextItemsBuilder_0;

  static filter(conditions: Record<string, any>): SysMLElementQueryBuilder;

  static filter(conditions: Record<string, any>): SysMLElementQueryBuilder {
    return new QueryBuilderImpl('SysMLElement').filter(conditions) as any;
  }

  static all(): SysMLElementQueryBuilder {
    return new QueryBuilderImpl('SysMLElement') as any;
  }

  static async first(): Promise<SysMLElement | null> {
    const results = await new QueryBuilderImpl('SysMLElement').execute();
    return results[0] || null;
  }


  static setQuery<Q extends SysMLElementQueryNames>(queryName: Q): SysMLElementBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('SysMLElement');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends SysMLElementQueryNames>(queryName: Q): SysMLElementInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = SysMLElement.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'member_namespace' - Python ORM style (cached)
  get member_namespace(): RelationshipManager<this, SysMLNamespace> {
    return this.getOrCreateRelationshipManager('member_namespace', () => {
      return new RelationshipManager(this, 'member_namespace', 'one', HasMembers as typeof Relationship);
    });
  }

}
